
import React from 'react';
import DOMPurify from 'dompurify';

interface ContentPreviewProps {
  content: string;
}

const ContentPreview: React.FC<ContentPreviewProps> = ({ content }) => {
  if (!content || !content.includes('<')) {
    return null;
  }

  // Enhance content for preview with proper styling and whitespace handling
  const enhancedContent = content
    // Proper paragraph styling
    .replace(/<p>/g, '<p style="margin-bottom: 1rem; line-height: 1.6; white-space: normal;">')
    // Ensure headers are well-styled
    .replace(/<h(\d)>/g, '<h$1 style="margin-top: 1.5rem; margin-bottom: 1rem; font-weight: bold; white-space: normal;">')
    // Image styling
    .replace(/<img /g, '<img style="max-width: 100%; height: auto; margin: 1rem 0; border-radius: 8px;" ')
    // Iframe (PDF) styling
    .replace(/<iframe /g, '<iframe style="width: 100%; height: 300px; margin: 1rem 0; border: none; border-radius: 8px;" ')
    // List items
    .replace(/<ul>/g, '<ul style="padding-left: 1.5rem; margin-bottom: 1rem; white-space: normal;">')
    .replace(/<ol>/g, '<ol style="padding-left: 1.5rem; margin-bottom: 1rem; white-space: normal;">')
    .replace(/<li>/g, '<li style="margin-bottom: 0.5rem; white-space: normal;">');

  const sanitizedContent = DOMPurify.sanitize(enhancedContent, {
    ALLOWED_TAGS: ['p','b','i','em','strong','a','ul','ol','li','br','h1','h2','h3','h4','h5','h6','img','iframe','span','div','blockquote','code','pre','hr'],
    ALLOWED_ATTR: ['href','title','target','rel','src','alt','style','class','width','height','allow','allowfullscreen','frameborder'],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|data:image\/):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
  });

  return (
    <div className="mt-4 border rounded-md p-4">
      <h3 className="text-sm font-medium mb-2">Voorbeeld:</h3>
      <div 
        className="prose prose-sm max-w-none dark:prose-invert overflow-auto max-h-[400px] p-4 bg-white dark:bg-gray-900 rounded"
        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
      />
    </div>
  );
};

export default ContentPreview;
